import { render } from "./CreditTemplate.vue?vue&type=template&id=5c2ec226&scoped=true&ts=true"
import script from "./CreditTemplate.vue?vue&type=script&lang=ts"
export * from "./CreditTemplate.vue?vue&type=script&lang=ts"

import "./CreditTemplate.vue?vue&type=style&index=0&id=5c2ec226&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2ec226"]])

export default __exports__